<!--  Column 1  -->
<div class="schedule-legend-column">

  <digires-milestone-category-icon [category]="category.COMMON_ACTIVITIES"></digires-milestone-category-icon>
  <digires-milestone-category-icon [category]="category.PROJECT_MANAGEMENT"></digires-milestone-category-icon>
  <digires-milestone-category-icon [category]="category.PROJECT_ECONOMICS"></digires-milestone-category-icon>

</div>
<!--  Column 2  -->
<div class="schedule-legend-column">

  <div class="schedule-legend-row">
    <div class="schedule-legend-item">
      <mat-icon [svgIcon]="categoryToIcon[category.GOVERNANCE_T1]"></mat-icon>
    </div>
    Governance
  </div>
  <digires-milestone-category-icon [category]="category.PERMIT"></digires-milestone-category-icon>
  <digires-milestone-category-icon [category]="category.GRID"></digires-milestone-category-icon>

</div>
<!--  Column 3  -->
<div class="schedule-legend-column">

  <digires-milestone-category-icon [category]="category.YIELD"></digires-milestone-category-icon>
  <digires-milestone-category-icon [category]="category.OTHER"></digires-milestone-category-icon>
  <digires-milestone-category-icon [category]="category.LAND"></digires-milestone-category-icon>

</div>
<!--  Column 4  -->
<div class="schedule-legend-column">

  <digires-milestone-category-icon [category]="category.CONTRACTS"></digires-milestone-category-icon>

  <div class="schedule-legend-row">

    <div class="schedule-legend-row">
      <div class="schedule-legend-item">
        <div class="schedule-legend-checkbox-disabled"></div>
      </div>
      Forecast
    </div>

    <div class="schedule-legend-row">
      <div class="schedule-legend-item">
        <div class="schedule-legend-checkbox-enabled">
          <svg focusable="false" viewBox="0 0 24 24">
            <path d="M4.1,12.7 9,17.6 20.3,6.3" fill="none"/>
          </svg>
        </div>
      </div>
      Completed
    </div>

  </div>

  <div class="schedule-legend-row">
    <div class="schedule-legend-item">
      <div class="dw-state-indicator readonly"></div>
    </div>
    Read Only (auto populated)
  </div>

</div>
<!--  Column 5  -->
<div class="schedule-legend-column">

  <div class="schedule-legend-row">
    <div class="schedule-legend-item">
      <mat-icon class="schedule-legend-mat-icon">vpn_key</mat-icon>
    </div>
    Key Milestone (Defines End of Stage)
  </div>

  <div class="schedule-legend-row">
    <div class="schedule-legend-item">
      <mat-icon class="schedule-legend-mat-icon" svgIcon="milestone_include_if_hybrid"></mat-icon>
    </div>
    Include if 'Hybrid?' = Yes
  </div>

  <div class="schedule-legend-row">
    <div class="schedule-legend-item">
      <mat-icon class="schedule-legend-mat-icon" svgIcon="milestone_include_if_divestment"></mat-icon>
    </div>
    Include if Divestment Project
  </div>
</div>
